module.exports = __webpack_public_path__ + "media/src/images/partners/usi-21b259756bc866cd74ed6c37e20cea4f.jpg";